var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCanada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_7590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.75 75C58.4607 75 75.25 58.2107 75.25 37.5C75.25 16.7893 58.4607 0 37.75 0C17.0393 0 0.25 16.7893 0.25 37.5C0.25 58.2107 17.0393 75 37.75 75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2499 37.4999C75.2499 22.6327 66.5978 9.78657 54.0542 3.72095V71.2788C66.5978 65.2133 75.2499 52.3672 75.2499 37.4999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.25 37.4999C0.25 52.3672 8.9021 65.2133 21.4457 71.2789V3.72095C8.9021 9.78657 0.25 22.6327 0.25 37.4999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2717 42.3912L50.7934 39.1303L47.5326 37.5V34.2391L41.0108 37.5L44.2717 30.9782H41.0108L37.7499 26.0869L34.4891 30.9782H31.2282L34.4891 37.5L27.9673 34.2391V37.5L24.7065 39.1303L31.2282 42.3912L29.5978 45.6521H36.1196V50.5434H39.3803V45.6521H45.9021L44.2717 42.3912Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_7590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCanada);
export default __webpack_public_path__ + "static/media/flagCanada.f38e9a086547f1dea4cf5998d5e7d1e7.svg";
export { ForwardRef as ReactComponent };